module.exports = __webpack_public_path__ + "static/client-5-e31acb144db320fe3be86e82780ea8e1.jpg";